import Badge from '../Badge';
import React from 'react';

type TopBannerConfig = {
    titleLabel?: string;
    blackgroundColor?: string;
    badgeBorderColor?: string;
    statusBadge: (status: number | null) => {backgroundColor: string; label: string};
    actionComponents: (status: number | null) => React.ReactNode;
    leftComponent?: () => React.ReactNode;
    centerInfo?: boolean;
}

type TopBannerProps = {
    title?: string | null;
    status?: number | null;
    config: TopBannerConfig;
}

const TopBanner = ({title = null, status = null, config}: TopBannerProps) => {
    const statusBadge = (!status && typeof status !== 'number') ? null : config.statusBadge(status);

    return (
        <div className={`flex flex-row justify-between items-center h-32 ${config.blackgroundColor || 'bg-red-50'} pl-24 pr-16`}>
            {config.leftComponent && config.leftComponent()}

            <div className={`${config.centerInfo ? 'mx-auto' : ''} w-fit`}>
                {
                    title &&
                    <p className='mb-2 text-4xl font-bold text-white' style={{fontFamily: 'DIN Condensed'}}>
                        {config.titleLabel || ''}{title}
                    </p>
                }
                {
                    statusBadge &&
                    <Badge
                        color={statusBadge.backgroundColor}
                        borderColor={config.badgeBorderColor}
                        content={statusBadge.label}
                    />
                }
            </div>

            <div>
                {config.actionComponents && config.actionComponents(status)}
            </div>
        </div>
    );
};

export default TopBanner;
